import { useState } from 'react';
import { Button } from '../../ui/Button';

/*
 * Invite controls. `CopyInviteButton` copies this table's invite link
 * (/join/<code>) to the clipboard and flashes a confirmation. The link brings
 * players — including brand-new ones — straight to this game.
 */

export const buildInviteLink = (code: string) => `${window.location.origin}/join/${code}`;

interface CopyInviteButtonProps {
  tableCode: string;
  label?: string;
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  style?: React.CSSProperties;
}

export const CopyInviteButton = ({
  tableCode,
  label = 'Invite',
  variant = 'ghost',
  size = 'sm',
  style,
}: CopyInviteButtonProps) => {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    const link = buildInviteLink(tableCode);
    try {
      await navigator.clipboard.writeText(link);
    } catch {
      // Clipboard API unavailable (e.g. insecure context): fall back to prompt.
      window.prompt('Copy this invite link:', link);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={copy}
      style={style}
      aria-label="Copy invite link"
    >
      {copied ? 'Link copied!' : label}
    </Button>
  );
};
